import React from 'react';
import NavigationModel from '../../../components/CustomNavigation/NavigationModel';

const CourseAttendanceTypeModuleNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const redirectUrl = `${phpNavigationUrl}/course/index2`;
  return <NavigationModel redirectUrl={redirectUrl} title="Course Attendance Type Module" navigationTo={'Old Portal'} />;
};

export default CourseAttendanceTypeModuleNavigation;
